// Import Actions
import { SET_CONVERSATIONS, ADD_CONVERSATIONS, UPDATE_CONVERSATION, REMOVE_CONVERSATION, SET_CONVERSATION_MESSAGES, SET_SENDING_MESSAGE, ADD_CONVERSATION_MESSAGE, SET_MESSAGE_WRITTING } from './ConversationActions';

// Initial State
export const initialState = {
    data: [],
    isSending: false,
    newMessageIndex: 0,
};

const ConversationReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_CONVERSATIONS:
            return {
                ...state,
                data: action.conversations,
            };

        case ADD_CONVERSATIONS: {
            return {
                ...state,
                data: [
                    ...state.data.filter(conversation => !action.conversations.find(newConversation => conversation._id === newConversation._id)),
                    ...action.conversations.map(newConversation => {
                        const existingConversation = state.data.find(conversation => conversation._id === newConversation._id);
                        return {
                            ...(existingConversation || {}),
                            ...newConversation,
                        };
                    }),
                ],
            };
        }

        case UPDATE_CONVERSATION:
            return {
                ...state,
                data: state.data.map(conversation => {
                    if(conversation._id === action.conversation._id) {
                        return {
                            ...conversation,
                            ...action.conversation,
                            messages: action.conversation.messages || conversation.messages,
                        };
                    }
                    return conversation;
                }),
            };

        case REMOVE_CONVERSATION:
            return {
                ...state,
                data: state.data.filter(conversation => conversation._id !== action.conversationId),
            };

        case SET_CONVERSATION_MESSAGES:
            return {
                ...state,
                data: state.data.map(conversation => {
                    if(conversation._id === action.conversationId) {
                        return {
                            ...conversation,
                            messages: action.messages,
                        };
                    }
                    return conversation;
                }),
            };

        case SET_SENDING_MESSAGE:
            return {
                ...state,
                isSending: true,
            };

        case ADD_CONVERSATION_MESSAGE:
            return {
                ...state,
                isSending: false,
                data: state.data.map(conversation => {
                    if(conversation._id === action.message.conversation._id) {
                        if(!conversation.messages) {
                            conversation.messages = [];
                        }
                        return {
                            ...conversation,
                            messages: [...conversation.messages, action.message],
                        };
                    }
                    return conversation;
                }),
                newMessageIndex: state.newMessageIndex + 1,
            };

        case SET_MESSAGE_WRITTING:
            return {
                ...state,
                data: state.data.map(conversation => {
                    if(conversation._id === action.conversationId) {
                        if(!conversation.writingUsers) {
                            conversation = {
                                ...conversation,
                                writingUsers: [],
                            };
                        }
                        if(action.isWritting) {
                            return {
                                ...conversation,
                                writingUsers: [
                                    ...conversation.writingUsers,
                                    action.user,
                                ],
                            };
                        }
                        return {
                            ...conversation,
                            writingUsers: conversation.writingUsers.filter(user => user._id !== action.user._id),
                        };
                    }
                    return conversation;
                }),
            };

        default:
            return state;
    }
};

export default ConversationReducer;
